import { Component, NgZone, OnInit } from '@angular/core';
import { PROJECTS } from '@core/enum/projects.enum';
import { ModalErrorConfig } from '@core/interfaces/modal-error-config.interface';
import { MessageBusService, MicroFrontendRouter } from '@xdig/ng-microkernel/micro-frontend';
import { TIME_OUT_CONFIG } from './time-out.component.config';
import { ModalService } from '../../modal.service';

@Component({
  selector: 'shell-time-out',
  templateUrl: './time-out.component.html',
})
export class TimeOutComponent implements OnInit {
  config: ModalErrorConfig;
  modalError: any;

  constructor(
    private modalService: ModalService,
    public microFrontendRouter: MicroFrontendRouter,
    public messageBusService: MessageBusService,
    public ngZone: NgZone,
  ) {}

  closeModal() {
    switch (this.modalError?.project) {
      case PROJECTS.ACC:
        this.microFrontendRouter.navigateByUrl('/inicio', 'inicio');
        break;
      case PROJECTS.PLD:
        this.microFrontendRouter.navigateByUrl('/inicio', 'inicio');
        break;
      case PROJECTS.FTD:
        this.microFrontendRouter.navigateByUrl('/inicio', 'inicio');
        break;
      case PROJECTS.ENROLLMENT:
        this.microFrontendRouter.navigateByUrl('/inicio', 'inicio');
        break;
    }
    this.modalService.close();
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.ngZone.run(() => {
        this.modalError = this.messageBusService.getValue('shell', 'modal.error');
        this.config = TIME_OUT_CONFIG.get(this.modalError?.project) as ModalErrorConfig;
      });
    });
  }
}
